export default {
  korean_list(state) {
    return state.korean_list;
  },
};
